import { Box, Flex, Heading, Text } from "rebass";
import * as moment from "moment";
import styled from "styled-components";
import { maxWidth } from "styled-system";
import { theme } from "../styles/theme";
import { Module } from "./module";
import { Button } from "./button";

//  title: string
//  link: { internal: bool, href: string, as: string }
//  cta: string
//  items: {
//    link: { internal: bool, href: string, as: string },
//    image: { alt: string, url: string },
//    title: string,
//    details: string,
//    description: string,
//    cta: string,
//    whiteText: bool
//  } []
//  whiteText: bool
const ModuleGrid = ({ title, link, cta, items, whiteText = false }) => {
  return (
    <Inner mx="auto" maxWidth={3}>
      {title && (
        <Title
          mb={[4, 5, 6]}
          lineHeight={1}
          textAlign="center"
          as="h2"
          fontFamily="medium"
          letterSpacing={1}
          fontSize={[4, 4, 5, 6]}
          color={whiteText ? "white" : "blue.2"}
        >
          {title}
        </Title>
      )}
      <Flex
        mx={[
          -theme.space[3] / 2,
          -theme.space[3] / 2,
          -theme.space[3] / 2,
          -theme.space[4] / 2
        ]}
        flexWrap="wrap"
      >
        {items.map((item, i) => (
          <Flex
            key={i}
            width={[1, 1 / 2, 1 / 3]}
            px={[
              theme.space[3] / 2,
              theme.space[3] / 2,
              theme.space[3] / 2,
              theme.space[4] / 2
            ]}
            mt={[i > 0 ? 4 : 0, i > 1 ? 5 : 0, i > 2 ? 5 : 0]}
          >
            <Module
              link={item.link}
              image={item.image}
              title={item.title}
              details={item.details}
              description={item.description}
              cta={item.cta}
              whiteText={whiteText}
            />
          </Flex>
        ))}
      </Flex>
      {cta && (
        <Text mt={[3, 4, 5]} textAlign="center">
          <Button text={cta} link={link} />
        </Text>
      )}
    </Inner>
  );
};

const Inner = styled(Box)`
  ${maxWidth}
`;

const Title = styled(Heading)`
  text-transform: uppercase;
`;

export { ModuleGrid };
